export default "__VITE_ASSET__f333b085__"